const s = {
  name: "DevelopmentTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8.7,7.7L6.4,10l2.3,2.3l-1.4,1.4L3.6,10l3.7-3.7L8.7,7.7z"/>
		<path class="st0" d="M17.6,10l-2.3-2.3l1.4-1.4l3.7,3.7l-3.7,3.7l-1.4-1.4L17.6,10z"/>
		<path class="st0" d="M11.8,16.2l2.4-12l-2-0.4l-2.4,12L11.8,16.2z"/>
		<path class="st0" d="M0,3.9C0,1.7,1.7,0,3.9,0h16.3C22.3,0,24,1.7,24,3.9v12.3c0,2.1-1.7,3.9-3.9,3.9H3.9C1.7,20,0,18.3,0,16.1
			V3.9z M3.9,2C2.8,2,2,2.8,2,3.9v12.3c0,1,0.8,1.9,1.9,1.9h16.3c1,0,1.9-0.8,1.9-1.9V3.9c0-1-0.8-1.9-1.9-1.9H3.9z"/>
		<path class="st0" d="M7,22h10v2H7V22z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as DevelopmentTeam
};
